import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import App from './App';
import store from 'store/store';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import jllTheme from '@jll/jll.capability.designsystem.restyles.mui';
import { I18nextProvider } from 'react-i18next';
import i18n from 'i18n';

const container = document.getElementById('root') || document.createElement('div');
const root = ReactDOM.createRoot(container);
root.render(
  <Router>
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
        <ThemeProvider theme={jllTheme}>
          <App />
        </ThemeProvider>
      </Provider>
    </I18nextProvider>
  </Router>,
);
